export default {
    // namespaced:true,
    state:{
        classID:'',
        classType:null,
        isCollects:false,
        isDuihuan:false,
        classTitle:'',
        classNavLevel:[],
        schoolClassNav:[],
        prevRoute:'',
        studentFileArr:[],
        mutilcommentArr:[],
        teacherkejianArr:[],
    },
    mutations:{
        pushClassId(state,data){
            console.log('data')
            console.log(data)
            state.classID=data;
        },
        changeCollectStatus(state,data){
            console.log(data)
            state.isCollects=data;
        },
        pushClassType(state,data){
            state.classType=data;
        },
        pushClassTitle(state,data){
            state.classTitle=data;
        },
        changeDuiHuanStatus(state,data){
            state.isDuihuan=data;
        },
        changeClassNavLevel(state,data){
            console.log(data)
            state.classNavLevel=data;
        },
        changeSchoolClassNav(state,data){
            state.schoolClassNav=data;
        },
        changePrevRoute(state,data){
            console.log(data)
            state.prevRoute=data
        },
        changeStrdentFileArr(state,data){
            state.studentFileArr=data
        },
        changemutiCommentArr(state,data){
            state.mutilcommentArr=data
        },
        changeTeacherKejianArr(state,data){
            state.teacherkejianArr=data;
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/class.js